import { useTranslation } from 'react-i18next';

const FALLBACK_LOCALE = 'en';

export const useLocale = (): string => {
  const { i18n } = useTranslation();
  return i18n.language || FALLBACK_LOCALE;
};
